import React, { useState } from "react";
import { login } from "../api";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [password, setPassword] = useState("");
  const [status, setStatus] = useState("");
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setStatus("Signing in...");
    try {
      const { token } = await login(password);
      localStorage.setItem("token", token);
      setStatus("Success");
      navigate("/mic/forAll/mehdi/admin");
    } catch {
      setStatus("Invalid password");
    }
  }

  return (
    <div>
      <h1>Button Design</h1>
      <form onSubmit={handleSubmit} className="login-form">
        <input
          type="password"
          placeholder="Admin password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{
            backgroundColor: "#f0f0f0",
            border: "1px solid #ccc",
            borderRadius: "5px",
            padding: "10px",
            fontSize: "16px",
            width: "10px",
          }}
        />
        <button
          type="submit"
          style={{
            marginLeft: "10px",
            padding: "10px 20px",
            fontSize: "16px",
            borderRadius: "5px",
            border: "none",
            backgroundColor: "#63A361",
            color: "white",
            cursor: "pointer",
          }}
        >
          Login
        </button>
      </form>
      <div className="status">{status}</div>

      <br />
      <button
        type="submit"
        style={{
          marginLeft: "10px",
          marginRight: "15px",
          padding: "10px 20px",
          fontSize: "16px",
          borderRadius: "5px",
          border: "none",
          backgroundColor: "#BF1A1A",
          color: "white",
          cursor: "pointer",
        }}
      >
        Logout
      </button>
      <br />
      <br />
      <button
        style={{
          marginLeft: "10px",
          marginRight: "15px",
          padding: "10px 20px",
          fontSize: "16px",
          borderRadius: "5px",
          border: "none",
          backgroundColor: "#FFC50F",
          color: "black",
          cursor: "pointer",
        }}
      >
        Edit
      </button>
    </div>
  );
}
